export type BulletOwner = 'player' | 'enemy';

export interface Bullet {
  x: number;
  y: number;
  vy: number;
  owner: BulletOwner;
}

export interface PlayerBulletSource {
  x: number;
  y: number;
  width: number;
}

export interface EnemyBulletSource {
  x: number;
  y: number;
  width: number;
  height: number;
}

export const PLAYER_BULLET_SPEED = 700;
export const ENEMY_BULLET_SPEED = 250;

export function spawnPlayerBullet(source: PlayerBulletSource): Bullet {
  return {
    x: source.x + source.width / 2,
    y: source.y,
    vy: -PLAYER_BULLET_SPEED,
    owner: 'player',
  };
}

export function spawnEnemyBullet(source: EnemyBulletSource): Bullet {
  return {
    x: source.x + source.width / 2,
    y: source.y + source.height,
    vy: ENEMY_BULLET_SPEED,
    owner: 'enemy',
  };
}

export function updateBullets(
  bullets: readonly Bullet[],
  dtMs: number,
  canvasHeight: number,
): Bullet[] {
  if (bullets.length === 0) return [];
  const dtS = dtMs > 0 ? dtMs / 1000 : 0;
  const result: Bullet[] = [];
  for (const b of bullets) {
    const ny = b.y + b.vy * dtS;
    if (ny < 0 || ny > canvasHeight) continue;
    result.push({ x: b.x, y: ny, vy: b.vy, owner: b.owner });
  }
  return result;
}
